"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const getCategory = (post: any) => {
  if (post.categories && post.categories.length > 0) {
    return post.categories[0].name;
  }
  return "Tokoh";
};
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="19462" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 h-full">
        <div className="lg:col-span-2 h-[600px] bg-muted animate-pulse rounded-[6px]" />
        <div className="flex flex-col gap-8 h-full">
          <div className="flex-1 bg-muted animate-pulse rounded-[6px]" />
          <div className="flex-1 bg-muted animate-pulse rounded-[6px]" />
        </div>
      </div>;
  }
  if (error) {
    return <div className="py-20 text-center">
        <p className="text-muted-foreground mb-4">Gagal memuat rubrik opini terbaru.</p>
        <Button variant="link" onClick={() => refetch()} className="text-primary underline underline-offset-4 hover:text-primary/80">
          Coba Lagi
        </Button>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-20 text-center">
        <p className="text-muted-foreground">Belum ada artikel opini yang tersedia.</p>
      </div>;
  }
  const featuredPost = posts[0];
  const sidePosts = posts.slice(1, 3);
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-y-10 md:gap-x-8 lg:gap-x-10">
      {}
      <div className="md:col-span-12 lg:col-span-8 group" data-index={0}>
        <Link to={featuredPost.link || "#"} className="block space-y-6">
          <div className="overflow-hidden bg-muted rounded-[6px]">
            <AspectRatio ratio={16 / 10}>
              {featuredPost.featuredImage ? <img src={featuredPost.featuredImage} alt={featuredPost.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-secondary/30 text-muted-foreground">
                  <span className="font-sans italic">Gambar Tidak Tersedia</span>
                </div>}
            </AspectRatio>
          </div>
          
          <div className="space-y-3 max-w-3xl">
            <Badge variant="secondary" className="rounded-none border-none bg-transparent px-0 text-sm font-sans font-semibold tracking-wider text-primary hover:bg-transparent shadow-none uppercase">
              {getCategory(featuredPost)}
            </Badge>
            <h3 className="font-sans text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold leading-[1.1] text-foreground group-hover:text-primary transition-colors duration-300">
              {featuredPost.title}
            </h3>
          </div>
        </Link>
      </div>

      {}
      <div className="md:col-span-12 lg:col-span-4 flex flex-col gap-10 md:gap-6 lg:gap-8">
        {sidePosts.map((post, i) => <div key={post.id} className="group flex flex-col h-full border-b border-border/40 pb-8 last:border-0" data-index={i + 1}>
            <Link to={post.link || "#"} className="block space-y-4 h-full">
              <div className="overflow-hidden bg-muted rounded-[6px]">
                <AspectRatio ratio={3 / 2}>
                  {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-secondary/30 text-muted-foreground">
                      <span className="font-sans italic">Gambar Tidak Tersedia</span>
                    </div>}
                </AspectRatio>
              </div>
              
              <div className="space-y-2">
                <Badge variant="secondary" className="rounded-none border-none bg-transparent px-0 text-xs font-sans font-semibold tracking-wider text-primary hover:bg-transparent shadow-none uppercase">
                  {getCategory(post)}
                </Badge>
                <h4 className="font-sans text-base sm:text-lg md:text-2xl font-bold leading-tight text-foreground group-hover:text-primary transition-colors duration-300">
                  {post.title}
                </h4>
              </div>
            </Link>
          </div>)}
      </div>
    </div>;
}
export default function LatestFromTheJournal() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="opini" className="bg-background text-foreground py-20 md:py-24 lg:py-28">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-border pb-6">
          <div>
            <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-[44px] leading-none font-bold tracking-tight text-foreground relative inline-block pb-4 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[4px] after:bg-primary">
              Opini
            </h2>
            <p className="mt-6 font-sans text-base sm:text-lg md:text-xl text-[#4A3728] max-w-xl leading-relaxed">
              Analisis mendalam dan pandangan kritis dari para pakar serta tokoh masyarakat mengenai isu terkini.
            </p>
          </div>
          <Link to="#" className="hidden md:inline-flex font-sans text-sm font-bold uppercase tracking-widest text-primary hover:text-primary/80 transition-colors border-b-2 border-primary hover:border-primary/80 pb-1">
            Lihat Semua Opini
          </Link>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <PostsGridConsumer />
        </PostsProvider>

        <div className="mt-12 md:hidden text-center">
          <Link to="#" className="inline-flex font-sans text-sm font-bold uppercase tracking-widest text-primary hover:text-primary/80 transition-colors border-b-2 border-primary hover:border-primary/80 pb-1">
            Lihat Semua Opini
          </Link>
        </div>
      </div>
    </section>;
}